import React from "react";
import "./index.less";

interface LoadingProps {
  size?: number;
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({
  size = 60,
  className = "",
}) => {
  return (
    <div
      className={`custom-loading ${className}`}
      style={{ width: size, height: size }}
    >
      <div
        className="loading-square square-1"
        style={{
          backgroundColor: "#021B3B",
          width: size * 0.4,
          height: size * 0.4,
        }}
      ></div>
      <div
        className="loading-square square-2"
        style={{
          backgroundColor: "#BDCBDA",
          width: size * 0.4,
          height: size * 0.4,
        }}
      ></div>
    </div>
  );
};

export default Loading;
